import { partnerLogos } from "@/mocks/site/content";

export default function TrustStrip() {
  // Duplicate the list so the loop is seamless (translateX(-50%) lands on the second copy)
  const loop = [...partnerLogos, ...partnerLogos];

  return (
    <section className="bg-white border-y border-ink-100 py-8 md:py-10">
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex flex-col md:flex-row md:items-center gap-6 md:gap-10">
        <div className="text-[11px] uppercase tracking-[0.18em] text-ink-400 font-semibold whitespace-nowrap shrink-0">
          Trusted &amp; Awarded
        </div>

        <div className="flex-1 min-w-0 overflow-hidden marquee-mask group">
          <div className="flex w-max animate-marquee group-hover:[animation-play-state:paused]">
            {loop.map((label, i) => (
              <div
                key={`${label}-${i}`}
                className="flex items-center gap-2 text-sm font-semibold text-ink-500 hover:text-ink-900 transition-colors px-6 whitespace-nowrap"
              >
                <i className="ri-award-fill text-brand-500 text-base"></i>
                <span>{label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}